import React from "react";

function ITstaffingContent() {
    return (
        <section className="skill-section bg-grey padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="video-wrap">
                            <img src="assets/img/post-14.jpg" alt="img" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="section-heading mb-30">
                            <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}>IT Staffing & Consulting </h2>
                            <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out">
                                Finding and retaining the right IT talent is a challenge in today’s competitive market. At <span style={{color : '#0A0909', fontWeight : 'bold'}}>TITA Technologies</span>, we provide:
                            </p>
                            <ul className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out" style={{ listStyleType: 'disc', paddingLeft: '20px'  }}>
                                <li>Expert Talent Pool: Access to highly skilled IT professionals.</li>
                                <li>Flexible Solutions: Options for permanent, contract, and project-based staffing.</li>
                                <li>Consulting Services: Insights to optimize team performance and project outcomes.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ITstaffingContent;
